/**
 * Gravur-Auswahl auf der PDP.
 *
 * Haelt vier Dinge synchron: die Popover-Auswahl, die Vorschau, die
 * Zusammenfassung in der Labelzeile und die versteckten Line-Item-Properties.
 * Solange nichts eingegeben ist, bleiben die Properties deaktiviert, damit
 * keine leere Gravurzeile in der Bestellung landet.
 *
 * Die Popover tragen die Theme-Klasse OptionSelector. Dadurch schliesst der
 * globale Klick-Handler aus main-product.liquid sie beim Klick daneben
 * automatisch mit. Genau deshalb muss der eigene Auf-/Zu-Klick die
 * Propagierung stoppen, sonst wuerde derselbe Handler ihn sofort wieder
 * zuklappen.
 */
(function () {
  'use strict';

  // Was die Gravurmaschine sicher setzen kann. Alles andere wird beim Tippen
  // still verworfen, statt den Kunden mit einer Fehlermeldung zu bremsen.
  var ALLOWED = /[^A-Za-z0-9À-ſ &.,\-'+/♡∞·]/g;

  var FACE = {
    block: 'veynou-engraving__face--block',
    script: 'veynou-engraving__face--script'
  };

  var FONT_LABEL = {
    block: { de: 'Blockschrift', en: 'Block letters' },
    script: { de: 'Schreibschrift', en: 'Script' }
  };

  function setup(root) {
    if (root.veynouEngravingReady) return;
    root.veynouEngravingReady = true;

    var panel = root.querySelector('[data-veynou-engraving-panel]');
    var summary = root.querySelector('[data-veynou-engraving-summary]');
    var input = root.querySelector('[data-veynou-engraving-input]');
    var count = root.querySelector('[data-veynou-engraving-count]');
    var maxOut = root.querySelector('[data-veynou-engraving-max]');
    var preview = root.querySelector('[data-veynou-engraving-preview]');
    var choiceLabel = root.querySelector('[data-veynou-engraving-choice-label]');
    var fontName = root.querySelector('[data-veynou-engraving-font-name]');
    var fontSample = root.querySelector('[data-veynou-engraving-font-sample]');
    var fontNameInline = root.querySelector('[data-veynou-engraving-font-name-inline]');
    var props = {};

    root.querySelectorAll('[data-veynou-engraving-prop]').forEach(function (el) {
      props[el.getAttribute('data-veynou-engraving-prop')] = el;
    });

    if (!input || !preview || !summary || !panel) return;

    var lang = document.documentElement.lang === 'de' ? 'de' : 'en';
    var state = { on: false, font: 'block' };

    // Die Vektorform kommt aus den Symbolknoepfen selbst. So gibt es nur eine
    // Quelle fuer die Zeichnung, und Snippet und Vorschau koennen nicht
    // auseinanderlaufen.
    var glyphs = {};
    root.querySelectorAll('[data-veynou-engraving-symbol]').forEach(function (btn) {
      var svg = btn.querySelector('svg');
      if (svg) glyphs[btn.getAttribute('data-veynou-engraving-symbol')] = svg;
    });

    // Schreibt Text und ersetzt dabei Symbolzeichen durch ihre Vektorform.
    // Bewusst ueber Textknoten statt innerHTML: der Kundentext wird nie als
    // Markup interpretiert.
    function paint(target, text) {
      target.textContent = '';
      var buffer = '';

      function flush() {
        if (!buffer) return;
        target.appendChild(document.createTextNode(buffer));
        buffer = '';
      }

      for (var i = 0; i < text.length; i++) {
        var glyph = glyphs[text.charAt(i)];
        if (!glyph) {
          buffer += text.charAt(i);
          continue;
        }
        flush();
        var copy = glyph.cloneNode(true);
        copy.setAttribute('class', 'veynou-engraving__glyph veynou-engraving__glyph--inline');
        target.appendChild(copy);
      }

      flush();
    }

    var labels = {};
    root.querySelectorAll('[data-veynou-engraving-choice]').forEach(function (el) {
      labels[el.getAttribute('data-veynou-engraving-choice')] = el.textContent.trim();
    });

    function closeAll() {
      root.querySelectorAll('[data-veynou-engraving-pop]').forEach(function (pop) {
        pop.setAttribute('aria-hidden', 'true');
      });
      root.querySelectorAll('[data-veynou-engraving-toggle]').forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'false');
      });
    }

    function mark(selector, active) {
      root.querySelectorAll(selector).forEach(function (el) {
        el.classList.toggle('veynou-engraving__value--on', el === active);
      });
    }

    // Ein Ring hat innen eine feste Laenge: passt der Text nicht, wird er
    // kleiner graviert, nicht abgeschnitten. Genau das macht das hier - ohne
    // die Anpassung schnitt die Vorschau auf schmalen Displays einfach ab und
    // der Kunde sah seine Gravur nie vollstaendig.
    function fitPreview() {
      preview.style.fontSize = '';
      if (!preview.clientWidth || preview.scrollWidth <= preview.clientWidth) return;

      var base = parseFloat(window.getComputedStyle(preview).fontSize);
      if (!base) return;

      var scaled = base * (preview.clientWidth / preview.scrollWidth);
      // Etwas Reserve, weil Laufweite und Kerning beim Verkleinern nicht
      // exakt linear mitgehen.
      preview.style.fontSize = Math.max(Math.floor(scaled * 0.98), 11) + 'px';
    }

    function render() {
      var text = input.value;
      var face = FACE[state.font];

      preview.className = 'veynou-engraving__band-text ' + face;
      paint(preview, text);
      fitPreview();

      // Das Eingabefeld zeigt die gewaehlte Schrift mit, damit die Wahl schon
      // beim Tippen sichtbar ist und nicht erst unten im Band.
      input.classList.remove(FACE.block, FACE.script);
      input.classList.add(face);

      var max = parseInt(root.getAttribute('data-max'), 10) || 0;
      if (count) count.textContent = String(text.length);

      if (fontName) fontName.textContent = FONT_LABEL[state.font][lang];
      if (fontNameInline) fontNameInline.textContent = FONT_LABEL[state.font][lang];
      if (fontSample) fontSample.className = face;
      if (choiceLabel) choiceLabel.textContent = state.on ? labels.on : labels.off;

      if (text.length === 0) {
        summary.textContent = state.on ? labels.on : labels.off;
        Object.keys(props).forEach(function (key) {
          props[key].disabled = true;
          props[key].value = '';
        });
        return;
      }

      // Was graviert wird, soll keine doppelten oder haengenden Leerzeichen
      // enthalten. Das Eingabefeld bleibt unveraendert, sonst kaempft der
      // Kunde beim Tippen gegen den Cursor.
      var clean = text.trim().replace(/\s+/g, ' ');

      paint(summary, clean);
      if (props.summary) {
        props.summary.disabled = false;
        props.summary.value = clean + ' · ' + FONT_LABEL[state.font][lang];
      }
      if (props.text) {
        props.text.disabled = false;
        props.text.value = clean;
      }
      if (props.font) {
        props.font.disabled = false;
        props.font.value = state.font;
      }
    }

    function sanitize() {
      // maxlength greift nur beim Tippen und Einfuegen. Wird der Wert anders
      // gesetzt, etwa durch Autofill oder eine Erweiterung, faengt das hier.
      var max = parseInt(root.getAttribute('data-max'), 10) || 0;
      var cleaned = input.value.replace(ALLOWED, '');
      if (max > 0 && cleaned.length > max) cleaned = cleaned.slice(0, max);
      if (cleaned !== input.value) {
        var pos = input.selectionStart - (input.value.length - cleaned.length);
        input.value = cleaned;
        try {
          input.setSelectionRange(pos, pos);
        } catch (error) {
          /* Manche Browser erlauben das bei type=text nicht - unkritisch. */
        }
      }
      render();
    }

    root.querySelectorAll('[data-veynou-engraving-toggle]').forEach(function (button) {
      button.addEventListener('click', function (event) {
        // Ohne das schliesst der globale Handler des Themes sofort wieder.
        event.stopPropagation();
        var key = button.getAttribute('data-veynou-engraving-toggle');
        var pop = root.querySelector('[data-veynou-engraving-pop="' + key + '"]');
        var open = pop.getAttribute('aria-hidden') === 'false';
        closeAll();
        if (!open) {
          pop.setAttribute('aria-hidden', 'false');
          button.setAttribute('aria-expanded', 'true');
        }
      });
    });

    root.querySelectorAll('[data-veynou-engraving-choice]').forEach(function (button) {
      button.addEventListener('click', function () {
        state.on = button.getAttribute('data-veynou-engraving-choice') === 'on';
        mark('[data-veynou-engraving-choice]', button);
        panel.hidden = !state.on;
        // Zurueck auf "Ohne Gravur" raeumt auch die Eingabe weg, sonst
        // wandert versehentlich eine unsichtbare Gravur in die Bestellung.
        if (!state.on) input.value = '';
        closeAll();
        render();
        if (state.on) input.focus();
      });
    });

    root.querySelectorAll('[data-veynou-engraving-font]').forEach(function (button) {
      button.addEventListener('click', function () {
        state.font = button.getAttribute('data-veynou-engraving-font');
        mark('[data-veynou-engraving-font]', button);
        closeAll();
        render();
      });
    });

    input.addEventListener('input', sanitize);

    // Beim Drehen des Geraets aendert sich die Bandbreite.
    window.addEventListener('resize', fitPreview);

    // Die Gravurschriften laden asynchron. Bis dahin misst fitPreview die
    // Ersatzschrift, die schmaler faellt - danach waere der Text zu breit und
    // wuerde abgeschnitten. Deshalb nach dem Laden noch einmal nachmessen.
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(fitPreview).catch(function () {});
    }

    root.querySelectorAll('[data-veynou-engraving-symbol]').forEach(function (button) {
      button.addEventListener('click', function () {
        var symbol = button.getAttribute('data-veynou-engraving-symbol');
        var max = parseInt(root.getAttribute('data-max'), 10) || 0;
        if (max > 0 && input.value.length >= max) return;

        var start = input.selectionStart;
        var end = input.selectionEnd;
        if (typeof start !== 'number') {
          start = input.value.length;
          end = start;
        }
        input.value = input.value.slice(0, start) + symbol + input.value.slice(end);
        input.focus();
        try {
          input.setSelectionRange(start + symbol.length, start + symbol.length);
        } catch (error) {
          /* siehe oben */
        }
        render();
      });
    });

    // Legierung und Zeichenlimit haengen an der Variante.
    root.veynouApplyVariant = function (variantId) {
      var island = root.querySelector('[data-veynou-engraving-data]');
      if (!island || !variantId) return;

      if (island.veynouData === undefined) {
        try {
          island.veynouData = JSON.parse(island.textContent).variants;
        } catch (error) {
          console.warn('[veynou-engraving] Datensatz nicht lesbar', error);
          island.veynouData = null;
        }
      }
      if (!island.veynouData) return;

      var entry = island.veynouData[String(variantId)];
      if (!entry) return;

      root.classList.remove(
        'veynou-engraving--metal-gold',
        'veynou-engraving--metal-white',
        'veynou-engraving--metal-rose'
      );
      root.classList.add('veynou-engraving--metal-' + entry.metal);

      if (entry.max) {
        root.setAttribute('data-max', String(entry.max));
        input.setAttribute('maxlength', String(entry.max));
        if (maxOut) maxOut.textContent = String(entry.max);
        if (input.value.length > entry.max) input.value = input.value.slice(0, entry.max);
      }
      render();
    };

    render();
  }

  function init() {
    document.querySelectorAll('[data-veynou-engraving]').forEach(setup);
  }

  function onVariant(variantId) {
    if (!variantId) return;
    document.querySelectorAll('[data-veynou-engraving]').forEach(function (root) {
      if (root.veynouApplyVariant) root.veynouApplyVariant(variantId);
    });
  }

  document.addEventListener('variant:change', function (event) {
    onVariant(event.detail && event.detail.variant && event.detail.variant.id);
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      onVariant(event && event.data && event.data.variant && event.data.variant.id);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
